import {
  TokenTextAppearance,
  Accordion as VWAccordion,
} from '@volkswagen-onehub/components-core';
import { type ReactNode } from 'react';
import { AccordionWrapper } from './Accordion.styles';
import AccordionHeadline from '../AccordionHeadline/AccordionHeadline';

export interface AccordionProps {
  title: ReactNode;
  subtitle?: string;
  titleAppearance?: TokenTextAppearance;
  children: ReactNode;
  /**
   * If used within AccordionGroup this property
   * is automatically controlled.
   *
   * Can be overriden explictly defining the property.
   */
  isOpen?: boolean;
  /**
   * If used within AccordionGroup this property
   * is automatically controlled.
   *
   * Can be overriden explictly defining the property.
   */
  onToggle?: (open: boolean) => void;
  id: string;
}

const Accordion = ({
  title,
  subtitle,
  children,
  onToggle,
  isOpen,
  id,
}: AccordionProps) => {
  // Generate consistent ids to target VW elements
  const headId = `${id}_head`;
  const bodyId = `${id}_body`;

  return (
    <AccordionWrapper headId={headId} bodyId={bodyId}>
      <VWAccordion
        id={id}
        headline={
          <AccordionHeadline
            title={title}
            subtitle={subtitle}
          />
        }
        isOpen={isOpen}
        onClick={() => onToggle?.(!isOpen)}
      >
        {children}
      </VWAccordion>
    </AccordionWrapper>
  );
};

export default Accordion;
